import { createApiClient } from "@sos/api-client";

import { env } from "../../app/env";
import { currentLanguage } from "../../app/i18n";
import { reportNetworkStatus } from "../offline/onlineStatus";

export const UNAUTHENTICATED_EVENT = "sos:unauthenticated";

/** The single API client instance (FE-01 FR-FE01-17). */
export const api = createApiClient({
  baseUrl: env.apiBaseUrl,
  getLanguage: currentLanguage,
  onUnauthenticated: () => window.dispatchEvent(new Event(UNAUTHENTICATED_EVENT)),
  // FE-04 FR-FE04-28: a request with no answer means offline until the next answer.
  onNetworkStatus: reportNetworkStatus,
  // Late-bound so tests (and the SW-less dev server) can replace the global fetch.
  fetch: (input, init) => globalThis.fetch(input, init),
});
